import React from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import useSev2TagCombobox from './hooks';

export const Sev2TagComboboxSchema = {
  uiOptions: {
    type: 'object',
    properties: {
      title: { type: 'string', title: 'Title', default: 'Tags' },
      description: {
        type: 'string',
        title: 'Description',
        default: 'Select tags',
      },
    },
  },
  returnValue: { type: 'array' },
};

export const Sev2TagCombobox = (
  props: FieldExtensionComponentProps<
    { name: string; phid: string }[],
    { title: string; description: string }
  >,
) => {
  const { onChange, rawErrors, required, formData, uiSchema } = props;

  const { loading, open, setOpen, options, searchTags } = useSev2TagCombobox();

  return (
    <FormControl
      margin="normal"
      required={required}
      error={rawErrors?.length > 0 && !formData}
    >
      <Autocomplete
        id="combo-box-tag"
        multiple
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        onInputChange={(_, value) => {
          searchTags(value);
        }}
        onChange={(_, values) => {
          const tags = values.map(value => ({
            name: value.fields.name,
            phid: value.phid,
          }));
          onChange(tags);
        }}
        getOptionSelected={(option, value) => option.phid === value.phid}
        getOptionLabel={option => option.fields.name}
        options={options}
        loading={loading}
        renderInput={params => (
          <TextField
            {...params}
            label={uiSchema?.['ui:options']?.title}
            variant="standard"
            helperText={uiSchema?.['ui:options']?.description}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
};
